import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import type { DocumentUpdateCommandProcessor } from '../../stream-processors/update-command-processor';
import type { AIFC_ACTION_CLASSIFICATION_METADATA } from '../../types/command-manager';
import type { PageUpdateStrategy } from '../page-update-strategy';

type AIFCActionClassificationMetadataPayload = Extract<
	ConfluenceUpdatePageCommandProperties,
	{ key: typeof AIFC_ACTION_CLASSIFICATION_METADATA }
>;

export class AdfActionMetadataStrategy implements PageUpdateStrategy {
	constructor(private processor: DocumentUpdateCommandProcessor) {}

	process(payload: ConfluenceUpdatePageCommandProperties): void {
		const { data } = payload as AIFCActionClassificationMetadataPayload;
		this.processor.setActionMetadata(data);
	}
}
